import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=bd00a43a&scoped=true&"
import script from "./contacts.vue?vue&type=script&lang=ts&"
export * from "./contacts.vue?vue&type=script&lang=ts&"
import style0 from "./contacts.vue?vue&type=style&index=0&id=bd00a43a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd00a43a",
  null
  
)

export default component.exports